import Pie from './Pie';
export default Pie;
export { default as Pie } from './Pie';